module.exports = __webpack_public_path__ + "img/presentation.9b24e5c3.svg";